import { ActionRequest, Notification } from '../types'
import { isActionRequestNotification } from '../utils/notification'
import useSubscribeEntityNotifications from './useSubscribeEntityNotifications'

type NotificationHandler = (notification: Notification<ActionRequest>) => void

export default function useSubscribeActionRequestNotifications(handle: NotificationHandler) {
  useSubscribeEntityNotifications((notification) => {
    if (isActionRequestNotification(notification)) {
      handle(notification as Notification<ActionRequest>)
    }
  })
}
